import client from '/src/services/client.js';
// Endpoint api paths
export default {
    deletePath : (bot_id, path_id) => client.delete(`bot/${bot_id}/path/${path_id}`),
    addPath : (bot_id, path) => client.post(`bot/${bot_id}/path`, path)
}